<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}


</style>
<template>
    <transition name="fade">
    <div v-if="level" class="row mt-3 mb-2">
        <div class="col-12">
            <label class="form-label">
                Berechnete Gabenhöhe in App übernehmen?
            </label>
            <div class="input-group">
                <button @click="toogleTransferLevel" type="button" class="btn  form-control" :class="{'btn-info': transferLevel_ }"
                :disabled="['view'].includes(mode)">
                    {{ labelLevel ? labelLevel : 'Unvollständige Eingaben' }}
                </button>
                <span class="input-group-text">
                    <input @click="transferLevelAllowed" class="form-check-input m-0" v-model="transferLevel_"
                    type="checkbox" :disabled="['view'].includes(mode)">
                </span>
            </div>
        </div>
    </div>
    </transition>
</template>
<script>

export default {
    name: 'Transfer Irrgitation Level',
    components: {
        
    },
    inject: [
        'state'
    ],
    props: {
        transferLevel: {
            type: Boolean,
            default: false
        },
        countStart: {
            type: Number,
            default: null
        },
        countEnd: {
            type: Number,
            default: null
        },
        mode: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            transferLevel_: false
        }
    },
    computed: {
       level: function () { 
            if (this.countStart !== null && this.countEnd !== null  && this.area !== null) {
                if (this.countStart < this.countEnd) {
                    // Level in mm
                    return (1000 * (this.countEnd-this.countStart)) / this.area;
                }
            }
            return null;
        },
        labelLevel: function () { 
            if ( this.level !== null ) {
                return '{} mm (auf {} ha)'.format(
                    this.level.toFixed(1),
                    (this.area / 10000).toFixed(1)
                ).replaceAll('.', ',');    
            }
            return null;
       }, 
       area: function () {
            let profile = this.state.profile.item();

            if (profile) {
                return profile.area;
            }            
            return null;
        }
    },
    methods: {
        transferLevelAllowed: function (event) {           
            if(event.target.checked === true && this.level === null ){
                event.preventDefault();
            }
        },
        toogleTransferLevel: function (event) {
            event.target.blur();
            event.preventDefault();
        
            if ( this.transferLevel === true ) {
                this.transferLevel_ = false;
            } else if (this.level !== null) {
                this.transferLevel_ = true;
            }
        }
    },
    watch: {
        transferLevel: function (new_value, old_value) {
            if ( new_value !== old_value ) {
                this.transferLevel_ = this.transferLevel;
            }
        },
        transferLevel_: function (new_value, old_value) {
            if ( new_value !== old_value ) {
                this.$emit('update:transferLevel', this.transferLevel_);
            }
        }
    },
    mounted: function () {
        this.transferLevel_ = this.transferLevel;    
    },
}

</script>